import {
    pxToRem,
    accordionTitleCustomSlotClassNames,
    searchableListSlotClassNames,
    pxArrayToRem,
    captionClassName,
    rangeSelectorSlotClassNames,
    accordionSlotClassNames,
    accordionTitleSlotClassNames,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const AccordionBase: StyleRule = ({ theme }) => ({
    '&:last-child': {
        borderBottom: 'none',
    },
    borderBottom: `1px solid ${theme.siteVariables.colorScheme.default?.foreground}`,
    [`& .${accordionSlotClassNames.title}`]: {
        padding: pxArrayToRem([18, 0]),
        cursor: 'pointer',
        fontSize: pxToRem(14),
        width: '100%',

        borderTop: `1px solid ${theme.siteVariables.colors.transparency.black['10%']}`,
        '& div': {
            fontSize: theme.siteVariables.fontSizes.caption03,
            lineHeight: 1.1,
            letterSpacing: 0,
            marginBottom: 0,
            height: 'auto',
            width: 'auto',
            overflow: 'hidden',
            display: 'flex',
            paddingRight: 0,
            paddingTop: 0,
        },
        '& div .title': {
            display: 'inline-block',
            width: 'unset',
            flexShrink: 0,
        },
        [`& .${accordionTitleCustomSlotClassNames.titleIndicator}`]: {
            flexShrink: 0,
            alignItems: 'center',
            justifyContent: 'end',
            [`& .${svgIconClassName}`]: {
                width: pxToRem(20),
                height: pxToRem(20),
                fill: theme.siteVariables.colors.transparency.black['20%'],
            },
        },
        '& div[aria-expanded="true"] .title': {
            whiteSpace: 'nowrap',
            display: 'inline-block',
            width: 'unset',
            [theme.screen.laptop]: {
                textDecoration: 'unset',
                whiteSpace: 'normal',
            },
        },

        '& div[aria-expanded="true"] .title-note': {
            flex: 1,
            display: 'block',
            textOverflow: 'ellipsis',
            [theme.screen.laptop]: {
                display: 'flex',
                justifyItems: 'center',
            },
        },
    },

    [`& .${accordionSlotClassNames.content}`]: {
        margin: pxArrayToRem([0, 0, 14, 0]),

        [`& .${searchableListSlotClassNames.input}`]: {
            height: pxToRem(48),
        },
    },

    [theme.screen.laptop]: {
        overflow: 'hidden',
        [`& .${accordionTitleSlotClassNames.contentWrapper}`]: {
            paddingRight: 0,
            paddingTop: 0,
        },
        [`& .${accordionSlotClassNames.title}`]: {
            padding: 0,
            cursor: 'pointer',
            fontSize: pxToRem(16),
            borderTop: `1px solid ${theme.siteVariables.colorScheme.default?.foreground}`,

            '& div': {
                fontSize: theme.siteVariables.fontSizes.caption03,
                lineHeight: theme.siteVariables.lineHeightSmall,
                letterSpacing: 0,
                marginBottom: 0,
                height: 'auto',
            },
            [`& .${accordionTitleCustomSlotClassNames.titleIndicator}`]: {
                width: 'fit-content',
                height: 'fit-content',
                marginRight: pxToRem(10),
                flexShrink: 0,
                alignItems: 'center',
                justifyContent: 'center',
                [`& .${svgIconClassName}`]: {
                    width: pxToRem(20),
                    height: pxToRem(20),
                    fill: theme.siteVariables.colorScheme.default?.foreground,
                },
            },
        },
        [`& .${accordionSlotClassNames.content}`]: {
            marginBottom: pxToRem(28),

            '& > .filter-pricingGroup': {
                marginTop: pxToRem(3),
            },

            [`& .${searchableListSlotClassNames.input}`]: {
                height: pxToRem(44),
            },

            [`& .${rangeSelectorSlotClassNames.title}`]: {
                fontSize: pxToRem(16),
            },
        },

        '& div[aria-expanded="true"]': {
            textDecoration: 'none',
        },
    },
});
export const AccordionTitle: StyleRule = ({ theme }) => ({
    width: '100%',
    overflow: 'hidden',
    [`& .title`]: {
        whiteSpace: 'nowrap',
        display: 'inline-block',
    },
    [`& .${captionClassName}.title-note`]: {
        marginLeft: pxToRem(4),
        color: theme.siteVariables.colors.grey[300],
        fontSize: pxToRem(14),
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        lineHeight: pxToRem(18),

        [`&:not(:empty)`]: {
            width: '-webkit-fill-available',
        },
    },

    [`& .${svgIconClassName}`]: {
        width: pxToRem(16),
        height: pxToRem(16),
        marginLeft: pxToRem(8),
        fill: theme.siteVariables.colors.transparency.black['20%'],
    },
    [theme.screen.laptop]: {
        [`& .${svgIconClassName}`]: {
            width: pxToRem(24),
            height: pxToRem(24),
            marginLeft: pxToRem(8),
            fill: theme.siteVariables.colors.charcoal[250],
        },
    },
});
